import { useEffect } from 'react';
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';

export default function IsmaelCalaPortfolio() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white text-gray-900 font-sans selection:bg-gray-200 selection:text-black">
      <title>Ismael Cala | Diseño Web y Estrategia Digital | Mood Agency</title>
      <meta name="description" content="Caso de éxito Ismael Cala: Diseño y desarrollo de plataforma web, estrategia de ecommerce y marketing digital para potenciar la marca personal del estratega de vida." />
      <meta name="keywords" content="Ismael Cala, diseño web, ecommerce, estrategia digital, marketing digital, marca personal, conferencias" />
      
      <Navbar />
      
      {/* Hero Section - Clean & Minimal like Home */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden bg-white">
        {/* Background Ripple Effect */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
          <div className="absolute w-[60vw] h-[60vw] bg-[radial-gradient(circle,var(--tw-gradient-stops))] from-gray-200 via-gray-100/50 to-transparent rounded-full blur-[80px] opacity-100 z-0"></div>
          <div className="w-[90vw] h-[90vw] border border-gray-200 rounded-full absolute opacity-40"></div>
          <div className="w-[70vw] h-[70vw] border border-gray-300 rounded-full absolute opacity-50"></div>
          <div className="w-[50vw] h-[50vw] border border-gray-300 rounded-full absolute opacity-60"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 text-center">
          <div className="mb-8 animate-fade-in-up">
            <span className="font-display text-[10px] tracking-[0.4em] text-gray-400 uppercase">
              CASO DE ÉXITO 2015
            </span>
          </div>
          
          <h1 className="font-display text-[12vw] md:text-[8vw] leading-none font-bold uppercase tracking-tighter text-gray-900 mb-8 animate-fade-in-up delay-100">
            ISMAEL CALA
          </h1>
          
          <p className="max-w-2xl mx-auto font-sans text-xl text-gray-500 font-light leading-relaxed animate-fade-in-up delay-200">
            Transformación digital integral: De la televisión a una plataforma global de bienestar.
          </p>
        </div>
      </section>

      {/* Key Metrics - Minimalist Grid */}
      <section className="py-20 px-6 bg-white border-t border-gray-100">
        <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">50+</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Viajes Vendidos</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">1000+</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Casos Atendidos</p>
          </div>
          <div className="text-center group">
            <div className="font-display text-6xl md:text-7xl font-bold text-gray-900 mb-2 group-hover:scale-105 transition-transform duration-500">360°</div>
            <p className="font-sans text-sm text-gray-400 uppercase tracking-widest">Ecosistema Digital</p>
          </div>
        </div>
      </section>

      {/* The Context - Clean Typography */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold text-gray-900 mb-12 uppercase">El Contexto</h2>
          <p className="font-sans text-xl md:text-2xl text-gray-500 leading-relaxed font-light">
            Tras su exitosa trayectoria en CNN en Español, Ismael Cala se consolidó como referente en emprendimiento social y mindfulness. Necesitaba una plataforma que estuviera a la altura de su marca personal para escalar su negocio de educación y experiencias.
          </p>
        </div>
      </section>

      {/* Visual Break - Full Width Image */}
      <section className="w-full h-[80vh] overflow-hidden">
        <img 
          src="/assets/images/portfolio/cala/banner-caso-cala.jpg" 
          alt="Ismael Cala Digital Experience" 
          className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-1000 ease-out"
        />
      </section>

      {/* The Challenge - Minimal List */}
      <section className="py-32 px-6 bg-gray-50">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-20 items-center">
          <div>
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 mb-8 uppercase leading-tight">
              Energizar el<br/>Mapa Digital
            </h2>
            <p className="font-sans text-lg text-gray-500 leading-relaxed mb-12">
              En 2015, Cala Enterprises nos planteó un doble reto: diseñar una plataforma ecommerce robusta y crear una estrategia de distribución para un portafolio diverso.
            </p>
          </div>
          <div className="space-y-12">
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Diversidad de Productos</h3>
              <p className="font-sans text-gray-500">Unificar la venta de conferencias, libros, meditaciones y viajes exclusivos en una sola experiencia.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Escalabilidad</h3>
              <p className="font-sans text-gray-500">Soportar picos de tráfico generados por la audiencia masiva de televisión y redes sociales.</p>
            </div>
            <div className="border-l border-gray-300 pl-8">
              <h3 className="font-display text-xl font-bold text-gray-900 mb-2 uppercase">Atención al Cliente</h3>
              <p className="font-sans text-gray-500">Gestionar eficientemente las consultas y soporte para productos de alto valor.</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Solution - Grid Layout */}
      <section className="py-32 px-6 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-20">
            <h2 className="font-display text-4xl md:text-5xl font-bold text-gray-900 uppercase">La Solución</h2>
          </div>

          <div className="grid md:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Plataforma Web</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Desarrollamos un ecommerce escalable con landing pages de alta conversión e infraestructura robusta para manejar el alto tráfico de sus lanzamientos.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Marketing Digital</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Implementamos campañas de publicidad en Google y Facebook Ads, junto con estrategias de email marketing automatizado y remarketing.
              </p>
            </div>
            <div className="bg-white p-12 hover:bg-gray-50 transition-colors duration-300">
              <h3 className="font-display text-2xl font-bold text-gray-900 mb-6 uppercase">Experiencia Cliente</h3>
              <p className="font-sans text-gray-500 leading-relaxed">
                Integramos un CRM para gestión de leads, un equipo de soporte vía chat y sistemas automatizados de recuperación de carritos.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Impact - Minimal Text */}
      <section className="py-32 px-6 bg-black text-white">
        <div className="max-w-7xl mx-auto text-center">
          <h2 className="font-display text-3xl md:text-4xl font-bold mb-20 uppercase tracking-widest">Resultados que Inspiran</h2>
          
          <div className="max-w-4xl mx-auto">
            <p className="font-display text-2xl md:text-4xl leading-tight mb-12">
              "La implementación de estas estrategias permitió a Cala Enterprises no solo vender productos, sino construir una comunidad digital leal y monetizar efectivamente su contenido."
            </p>
            <div className="w-20 h-1 bg-white mx-auto opacity-30"></div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
